(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('CampaignPartsController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'surveyCampaignService', 'campaign', 'parts'];

    function Controller($scope, topBarService, surveyCampaignService, campaign, parts) {
        $scope.campaign      = campaign;
        $scope.campaignParts = parts;

        $scope.addPart = function () {
            surveyCampaignService
                .createCampaignPart(campaign.SlugObject, $scope.partToAdd)
                .then(function (newPart) {
                    $scope.campaignParts.push(newPart);
                    $scope.partToAdd = {};
                });
        };

        $scope.removePart = function (part) {
            return surveyCampaignService
                .deleteCampaignPart(campaign.SlugObject, part)
                .then(function () {
                    $scope.campaignParts = _.reject($scope.campaignParts, { CampaignPartID: part.CampaignPartID });
                });
        };

        $scope.updatePart = function (part) {
            return surveyCampaignService.updateCampaignPart(campaign.SlugObject, part);
        };

        topBarService.setTitleAndIcon(campaign.TitleEN, 'fa fa-bullhorn', 'Questionnaire Builder', 'fa fa-list-alt');
    }
})();